import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
ReactDOM.createRoot(document.getElementById('root')!).render(<React.StrictMode data-id="element-187">
    <App data-id="element-188" />
  </React.StrictMode>);